import { FinalBannerState } from '../../enums/FinalBannerState';
import { isCharedi } from '../../utils/utils';
import { FinalButtonType } from '../../enums/FinalButtonType';
import { afterAnnouncement, finalPageAvailable, isIdentified, isStudent, itIsMyCompetition, schoolInFinal, schoolRegisteredForFinal, showPublishFinalWinners, teamMember } from './utils';

export const buildFinalSectionProps = (state, authState) => {

  let bannerState = FinalBannerState.beforeAnnouncement;
  let finalButtonType = null;
  let showWhatToExpect = false;
  let showLiveVideo = false;
  let showFinalButtonType = false;
  let finalDate = true;
  let showFinalRejected = false;
  let afterFinalIsFinishedMessage = false;

  if (window.config.theFinalRejected) {
    finalDate = false;
    showFinalRejected = true;
  }

  if (isCharedi()) {
    if (afterAnnouncement(state)) {
      if (!isIdentified(authState) || !itIsMyCompetition(state, authState))
        bannerState = FinalBannerState.afterUnidentifiedCharedi
      else
        bannerState = FinalBannerState.beforeAnnouncementCharedi
      return {
        bannerState: bannerState,
        showFinalRejected: showFinalRejected,
        finalDate: finalDate,
        showWhatToExpect: true,
        showLiveVideo: true,
      };
    }
    return {
      bannerState: FinalBannerState.beforeAnnouncementCharedi,
    };
  }

  //אחרי הכרזת עולים לגמר
  if (afterAnnouncement(state)) {
    showWhatToExpect = true;
    showLiveVideo = true;
    showFinalButtonType = true;
    //אם לא מזוהה
    if (!isIdentified(authState) || !itIsMyCompetition(state, authState))
      bannerState = FinalBannerState.afterUnidentified
    //אם הבית ספר לא עלה לגמר
    else if (!schoolInFinal(state))
      bannerState = FinalBannerState.afterNotAdvanced;
    //אם הבית ספר עלה לגמר
    else if (schoolInFinal(state)) {
      bannerState = FinalBannerState.afterAdvanced;
      if (!isStudent(state)) {
        if (!schoolRegisteredForFinal(state))
          finalButtonType = FinalButtonType.teacherRegister;
        else
          finalButtonType = FinalButtonType.updateRegistration;
      }
      else if (isStudent(state)) {
        finalButtonType = FinalButtonType.locked;
        if (finalPageAvailable(state) && teamMember(state))
          finalButtonType = FinalButtonType.finalDayStudent;
      }
    }
  }
  if (showPublishFinalWinners(state)) {
    showWhatToExpect = false;
    finalDate = false;
    afterFinalIsFinishedMessage = true;
    showLiveVideo = true;
    showFinalButtonType = true;
    finalButtonType = FinalButtonType.finalistsList;
    bannerState = FinalBannerState.afterPublishFinalWinners;
  }
  return {
    bannerState,
    finalButtonType,
    showWhatToExpect,
    showLiveVideo,
    showFinalButtonType,
    finalDate,
    showFinalRejected,
    afterFinalIsFinishedMessage,
  };
};
